import React from 'react';
import PropTypes from 'prop-types';
import EventSlideCard from './Calendar/EventCardTable';
import SvgIcon from './SvgIcon';

const daysList = [
    { day: 8, name: 'Чт', long: 'Четверг' },
    { day: 9, name: 'Пт', long: 'Пятница' },
    { day: 10, name: 'Сб', long: 'Суббота' },
    { day: 11, name: 'Вс', long: 'Воскресенье' },
    { day: 12, name: 'Пн', long: 'Понедельник' },
    { day: 13, name: 'Вт', long: 'Вторник' },
    { day: 14, name: 'Ср', long: 'Среда' },
    { day: 15, name: 'Чт', long: 'Четверг' },
    { day: 16, name: 'Пн', long: 'Пятница' },
    { day: 17, name: 'Сб', long: 'Суббота' },
    { day: 18, name: 'Вс', long: 'Воскресенье' },
    { day: 19, name: 'Пн', long: 'Понедельник' },
    { day: 20, name: 'Вт', long: 'Вторник' },
    { day: 21, name: 'Ср', long: 'Среда' },
    { day: 22, name: 'Чт', long: 'Четверг' },
    { day: 23, name: 'Пт', long: 'Пятница' },
    { day: 24, name: 'Сб', long: 'Суббота' },
    { day: 25, name: 'Вс', long: 'Воскресенье' }
];


class EventCard extends React.Component {
    static propTypes = {
        name: PropTypes.string.isRequired,
        // eslint-disable-next-line
        dayEvents: PropTypes.any,
        // eslint-disable-next-line
        allEvents: PropTypes.any
    };

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            events: this.props.dayEvents.length > 2
                ? [this.props.dayEvents[0], this.props.dayEvents[1]] : this.props.dayEvents
        };

        this.toggleClick = this.toggleClick.bind(this);
    }

    toggleClick(e) {
        const openState = !this.state.isOpen;
        this.setState({
            isOpen: openState,
            events: (openState) ?
                this.props.dayEvents : [this.props.dayEvents[0], this.props.dayEvents[1]]
        });
        e.preventDefault();
    }

    render() {
        console.log('FUCK', this.props.allEvents);
        return (
            <div className="event-card event-full-card">
                <div className="event-card__wrapper">
                    <div className="event-card__title">
                        <SvgIcon typeID={this.props.name} />
                        <span>{this.props.name}</span>
                    </div>
                    <div className={`events--card--wrap ${this.state.isOpen ? 'events--card--wrap--open' : ''}`}>
                        {this.state.events.map(eventId => (
                            <div className="event-card__event" key={eventId}>
                                <EventSlideCard
                                    data={this.props.allEvents[eventId].original}
                                    full={daysList.filter(
                                        item => item.day === this.props.allEvents[eventId].date.day
                                    )}
                                />
                            </div>
                        ))}
                    </div>
                    {this.props.dayEvents.length > 2 ?
                        <button
                            className={`event-card__more ${this.state.isOpen ? 'event-card__more_open' : ''}`}
                            onClick={this.toggleClick}
                        /> : ''}
                </div>
            </div>
        );
    }
}


export default EventCard;



// WEBPACK FOOTER //
// ./src/components/EventCard.jsx